



































import { Component, Mixins, Watch } from 'vue-property-decorator';
import { Warning } from '@/pages/profile/components';
import { Block, Smart } from './components';
import { RemoteEduMenu } from '@/pages/profile/modules';
import { NewsCard } from '@/pages/profile/components/';
import store from '@/pages/profile/store';
import { LoaderMixin } from '@/pages/profile/mixins';
import isIntalentCheck from '@/mixins/isIntalentCheck';
import isMentoringCheck from '@/mixins/isMentoringCheck';
import isRemoteEduCheck from '@/mixins/isRemoteEduCheck';
import { getAge } from '@/tools/getAgeFromBirthday';

import { ICabinet, ChildData, Children, TestResult, IUser } from './types';

@Component({
  components: {
    Warning,
    RemoteEduMenu,
    Block,
    Smart,
    NewsCard,
  },
  metaInfo: () => ({
    title: 'Кабинет',
  }),
})
export default class Cabinet
  extends Mixins(
    LoaderMixin,
    isIntalentCheck,
    isRemoteEduCheck,
    isMentoringCheck,
  )
  implements ICabinet {
  get id(): string {
    return store.state.id;
  }

  get selector(): number {
    return store.state.selector;
  }

  get user(): IUser {
    return this.$store.state.user;
  }

  get loading(): boolean {
    return this.user.loading;
  }

  get children(): Children {
    const { children } = this.user;
    return children
      ? children.map(
          ({
            id,
            municipality_id,
            birthday,
            first_name,
            last_name,
            intalent_result,
          }: ChildData) => ({
            id,
            municipality_id,
            birthday,
            first_name,
            last_name,
            intalent_result,
          }),
        )
      : [];
  }

  get child(): ChildData {
    const { children, selector } = this;
    return children.length ? children[selector] : {};
  }

  get isChild(): boolean {
    return !!Object.keys(this.child).length;
  }

  get name(): string {
    const { child, isChild } = this;
    return isChild ? `${child.first_name} ${child.last_name}` : 'обучающийся';
  }

  get testResult(): TestResult {
    const { child, isChild } = this;
    return isChild ? child.intalent_result : ({} as any);
  }

  get municipalityId(): string {
    return this.child.municipality_id || '';
  }

  get age(): string {
    return this.child.birthday ? getAge(this.child.birthday).toString() : '';
  }

  get newsCookie(): boolean {
    return this.$store.state.cabinetCookie;
  }

  @Watch('id', { immediate: true })
  onChangeChild(): void {
    if (this.children) this.setStatus('success');
  }

  created(): void {
    if (this.loading) this.setStatus('loading');
  }

  newsClick(): void {
    this.$router.push({ name: 'profile-mentoring' });
    this.$store.commit('setCabinetCookie', true);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/cabinet/Cabinet.vue